import { Alert } from 'foundations-components/transitional/components/Alert';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
function DisabledAdIntegrationWarning() {
  return /*#__PURE__*/_jsx(Alert, {
    type: "warning",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "newCustomerDataFilters.FilterFamilyGroupHeading.adIntegrationWarning"
    })
  });
}
export default DisabledAdIntegrationWarning;